let parallaxImg = document.querySelectorAll(".parallax-large-image");

if (parallaxImg.length) {
  jQuery(window).on("scroll", function () {
    jQuery(".parallax-img-container").each(function () {
      let scrollTopPosition = jQuery(window).scrollTop();
      let paraHeight = jQuery(this).height();
      let paraTop = jQuery(this).offset().top;
      let paraTopPos = scrollTopPosition + jQuery(this).position().top;
      let ParaTopPosFrom = Math.floor((scrollTopPosition - paraTop) / 5);
      if (scrollTopPosition > (paraTopPos - paraHeight) && scrollTopPosition < (paraTopPos + paraHeight + 100)) {
        jQuery(this).children().css({ objectPosition: `50% jQuery{ParaTopPosFrom}px` });
      }
    })
  })
}